/* eslint import/prefer-default-export: off */
import {
  setShowKycBanner,
  setShowSessionReminder,
  loadNewKycStrategies,
  loadRestrictions,
  loadKycStrategiesV2,
  loadSessionInfo,
  loadRdlInfo,
  loadXrdlInfo,
  closeRdlConfirmation,
  closeXrdlPrompt,
} from './ducks/session';

const session = {
  setShowKycBanner,
  setShowSessionReminder,
  loadNewKycStrategies,
  loadRestrictions,
  loadKycStrategiesV2,
  loadSessionInfo,
  loadRdlInfo,
  loadXrdlInfo,
  closeRdlConfirmation,
  closeXrdlPrompt,
};

export {
  session,
};
